import { useEffect } from 'react'
import { useConnect } from 'wagmi'
import { burnerConnector } from '../config/burnerConnector'

export function PaperWalletHandler() {
  const { connect } = useConnect()

  useEffect(() => {
    if (typeof window === 'undefined') return

    const hash = window.location.hash
    const params = new URLSearchParams(hash.replace('#', ''))
    const key = params.get('key') as `0x${string}` | null

    const savedKey = localStorage.getItem('burner_key') as `0x${string}` | null
    const activeKey = key ?? savedKey

    if (activeKey && activeKey.startsWith('0x')) {
      localStorage.setItem('burner_key', activeKey)
      connect({ connector: burnerConnector(activeKey) })
      if (window.location.hash) {
        window.history.replaceState(null, '', window.location.pathname + window.location.search)
      }
    }
  }, [connect])

  return null
}
